export const UPDATE_USER = 'user:updateUser';
export const UPDATE_ALERT = 'user:updateAlert';

export function updateUser(newUser) {
    console.log('updateUser', newUser)
    return {
        type: UPDATE_USER,
        payload: {
            user: newUser
        }
    }
}

export function updateAlert(message) {
    console.log('updateAlert', message)
    return {
        type: UPDATE_ALERT,
        payload: {
            alert: message
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/user-actions.js